const usePermissionConfig = () => {
  return {
    /*
    * 同步
    * 控制：批量同步；同步所有数据；同步
    * 跳转路由名称：
    * */
    SYNC: 'OPS-SPFW-SPXX-TB',
    /*
    * 同步辅料商品数据
    * 控制：同步辅料商品数据
    * 跳转路由名称：
    * */
    SYNCFLSP: 'OPS-SPFW-SPXX-TBFLSPSJ',
    /*
    * 删除
    * 控制：批量删除；删除
    * 跳转路由名称：
    * */
    DELETE: 'OPS-SPFW-SPXX-SC',
  };
};

export default usePermissionConfig;
